var _path, _ellipse;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRVideoClip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-419818e9-fd3a-41ad-baa8-7e863cc96fc8",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "#9E9E9E",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.17,20.6H3.83c-.95,0-1.89-.4-2.55-1.1-.66-.7-1.03-1.62-1.03-2.59V7.1c0-.98,.37-1.9,1.03-2.59,.67-.7,1.6-1.1,2.56-1.1H13.17c.95,0,1.89,.4,2.55,1.1,.66,.7,1.03,1.62,1.03,2.59v.38l3.48-1.83c.38-.2,.8-.28,1.21-.27,.42,.02,.83,.15,1.18,.38,.35,.23,.64,.54,.83,.91,.19,.36,.29,.77,.29,1.18v8.29c0,.41-.1,.82-.29,1.18-.2,.37-.48,.68-.83,.91-.35,.23-.76,.36-1.18,.38-.42,.03-.84-.07-1.21-.27l-3.48-1.83v.38c0,.98-.37,1.9-1.03,2.59-.67,.7-1.6,1.1-2.56,1.1ZM3.83,5.9c-.28,0-.54,.12-.75,.33-.21,.23-.34,.54-.34,.87v9.8c0,.33,.12,.64,.34,.87,.2,.21,.47,.33,.74,.33H13.17c.28,0,.54-.12,.75-.33,.21-.23,.34-.54,.34-.87V7.1c0-.33-.12-.64-.34-.87-.2-.21-.47-.33-.74-.33H3.83Zm12.92,7.79l4.52,2.37-.02-8.12-4.5,2.36v3.39Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.26,
    cy: 14.35,
    rx: 1.4,
    ry: 1.47
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRVideoClip);
export default __webpack_public_path__ + "static/media/r-video-clip.4e9702841b7e4199d8bc4572c63902e8.svg";
export { ForwardRef as ReactComponent };